module.exports = __webpack_public_path__ + "static/media/c42.52b0537a.png";